import { Link } from "react-router-dom";

/**
 * Shared application footer — mounted at the bottom of every authenticated
 * page for a consistent surface (Dashboard, Vehicles, Maintenance, …).
 *
 * Kept minimal on purpose: brand + year on the left, version tag on the right.
 * Uses the same design tokens as the rest of the console so light/dark just
 * work. The version value comes from `WHATS_NEW.version` to keep a single
 * source of truth — bump `/lib/whatsNew.js` when releasing.
 */
import { WHATS_NEW } from "@/lib/whatsNew";

export default function Footer({ className = "" }) {
  const year = new Date().getFullYear();
  return (
    <footer
      className={`mt-10 pt-6 border-t border-[var(--border-hover)] flex items-center justify-between text-xs text-[var(--text-faint)] ${className}`}
      data-testid="app-footer"
    >
      <span data-testid="app-footer-brand">MileageIQ Console · {year}</span>
      <span className="font-mono-data" data-testid="app-footer-version">
        v{WHATS_NEW.version}
      </span>
    </footer>
  );
}
